import { render, staticRenderFns } from "./favorite-woman.vue?vue&type=template&id=1510d999&scoped=true&"
import script from "./favorite-woman.vue?vue&type=script&lang=js&"
export * from "./favorite-woman.vue?vue&type=script&lang=js&"
import style0 from "./favorite-woman.vue?vue&type=style&index=0&id=1510d999&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510d999",
  null
  
)

export default component.exports